import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";


export default class SegmentModeSwitcherCon extends SwitcherContainer {
  constructor() {
    super({ 
      header: "Segment Mode", 
      coords: { vertical: { x: 0, y: 630 }, horizontal: { x: 120, y: 390 } },
      handleFunc: (v: boolean) => eventBus.emit(EnumEventBus.segmentMode, v)
    });
    eventBus.on(EnumEventBus.catMode, (v: boolean) => this.setActivation(v));
    eventBus.on(EnumEventBus.showSecondAngles, (v: boolean) => this.setActivation(v));
  }
}